import config from 'config'
import { Main } from 'components/masters'

import { get } from 'lodash'
import React from 'react'
import * as Page from 'containers/pages'

const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/payments`,
    exact: true,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        <Page.Payments
          {...props}
          params={get(props, 'match.params', {})}>
          <Page.PaymentsWaiting {...props} params={get(props, 'match.params', {})} />
        </Page.Payments>
      </Main>
    )
  }
]

export default routes
